import { Container } from './style.js';

const infoBlocksList = (props) => {
    return <Container>{props.children}</Container>;
};

export default infoBlocksList;
